import { render } from "./PerformanceModal.vue?vue&type=template&id=c5590f90&scoped=true"
import script from "./PerformanceModal.vue?vue&type=script&lang=js"
export * from "./PerformanceModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=c5590f90&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5590f90"]])

export default __exports__